import * as z from "zod/v4";

export const MinimalBrandCompetitorSchema = z.object({
  id: z.bigint(),
  competitorName: z.string(),
  website: z.string(),
  competitiveCategory: z.string(),
});
export type MinimalBrandCompetitor = z.infer<
  typeof MinimalBrandCompetitorSchema
>;

const BrandCompetitorAliasSchema = z.object({
  alias: z.string(),
  regexMatch: z.string(),
});
export const BrandCompetitorSchema = z.object({
  id: z.bigint(),
  competitorName: z.string(),
  website: z.string(),
  competitiveSummary: z.string(),
  competitiveCategory: z.string(),
  competitiveStrengths: z.string(),
  competitiveWeaknesses: z.string(),
  socialSentiment: z.string(),
  aliases: z.array(BrandCompetitorAliasSchema),
  lastAnalysisAt: z.date().nullable(),
});
export type BrandCompetitor = z.infer<typeof BrandCompetitorSchema>;
